import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authHeader = () => {
  const t = localStorage.getItem("intro_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const api = {
  base: API,

  async login(username, password) {
    const res = await axios.post(`${API}/admin/login`, { username, password });
    if (res.data?.token) localStorage.setItem("intro_token", res.data.token);
    return res.data;
  },

  async getExperts() {
    const res = await axios.get(`${API}/experts`);
    return res.data || [];
  },
  async seed(experts, settings, categories = [], investors = []) {
    return (await axios.post(`${API}/seed`, { experts, settings, categories, investors })).data;
  },
  async uploadFile(file) {
    const fd = new FormData();
    fd.append("file", file);
    const res = await axios.post(`${API}/upload`, fd, { headers: { ...authHeader() } });
    return res.data; // { url }
  },
  async getCategories() { return (await axios.get(`${API}/categories`)).data || []; },
  async createCategory(c) { return (await axios.post(`${API}/categories`, c, { headers: authHeader() })).data; },
  async updateCategory(id, c) { return (await axios.put(`${API}/categories/${id}`, c, { headers: authHeader() })).data; },
  async deleteCategory(id) { return (await axios.delete(`${API}/categories/${id}`, { headers: authHeader() })).data; },
  async getInvestors() { return (await axios.get(`${API}/investors`)).data || []; },
  async createInvestor(i) { return (await axios.post(`${API}/investors`, i, { headers: authHeader() })).data; },
  async updateInvestor(id, i) { return (await axios.put(`${API}/investors/${id}`, i, { headers: authHeader() })).data; },
  async deleteInvestor(id) { return (await axios.delete(`${API}/investors/${id}`, { headers: authHeader() })).data; },
  async createExpert(expert) {
    return (await axios.post(`${API}/experts`, expert, { headers: authHeader() })).data;
  },
  async updateExpert(id, expert) {
    return (await axios.put(`${API}/experts/${id}`, expert, { headers: authHeader() })).data;
  },
  async deleteExpert(id) {
    return (await axios.delete(`${API}/experts/${id}`, { headers: authHeader() })).data;
  },

  async getSettings() {
    const res = await axios.get(`${API}/settings`);
    return res.data || {};
  },
  async putSettings(settings) {
    return (await axios.put(`${API}/settings`, settings, { headers: authHeader() })).data;
  },

  async addSubscriber(email) {
    return (await axios.post(`${API}/subscribers`, { email })).data;
  },
  async listSubscribers() {
    return (await axios.get(`${API}/subscribers`, { headers: authHeader() })).data || [];
  },

  async addBooking(booking) {
    return (await axios.post(`${API}/bookings`, booking)).data;
  },
  async listBookings() {
    return (await axios.get(`${API}/bookings`, { headers: authHeader() })).data || [];
  },

  async addApplication(payload) {
    return (await axios.post(`${API}/applications`, payload)).data;
  },
  async listApplications() {
    return (await axios.get(`${API}/applications`, { headers: authHeader() })).data || [];
  },
};

// Ensures DB is seeded from mock on first load, returns experts + settings + categories + investors.
export const ensureData = async (mockExperts, mockSettings, mockCategories = [], mockInvestors = []) => {
  let [experts, settings, categories, investors] = await Promise.all([
    api.getExperts(), api.getSettings(), api.getCategories(), api.getInvestors(),
  ]);
  if (!experts.length || !categories.length || !investors.length) {
    await api.seed(mockExperts, mockSettings, mockCategories, mockInvestors);
    [experts, settings, categories, investors] = await Promise.all([
      api.getExperts(), api.getSettings(), api.getCategories(), api.getInvestors(),
    ]);
  }
  return { experts, settings, categories, investors };
};
